export const AmendsChangeType = Object.freeze({
    ADDED: "added",
    UPDATED: "updated",
    REMOVED: "removed",
})

export function isAmendsChangeType(value) {
    return Object.values(AmendsChangeType).includes(value)
}
